<template>
  <el-dialog
    top='20px'
    :visible="dialogVisible"
     title="编辑规范"
     width="1400px"
     @open="open"
     @close="close"
  >
    <img src="https://files.mankoo.cn/group1/M00/BB/7B/rBGknWP3Gk2ARI6QACJpndIz7HQ212.png" alt="" style = "width: 100%">
  </el-dialog>
</template>

<script>
  export default {
    props: {
      dialogVisible: Boolean
    },
    methods: {
      open() {

      },
      close() {
        this.$emit('close')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/dialog/report-course-dialog.vue